export const ACTIONS = {
	SET_COPIED_TO_CLIPBOARD: 'SET_COPIED_TO_CLIPBOARD',
	SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS: 'SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS',
	SET_IS_WRAPPED: 'SET_IS_WRAPPED',
	SET_AUTO_DETECT_ENTRY: 'SET_AUTO_DETECT_ENTRY',
	REMOVE_AUTO_DETECT_ENTRY: 'REMOVE_AUTO_DETECT_ENTRY',
};
